import { html } from 'htm/preact';

const Skeleton = () => {
  return html`
    <div class="animate-pulse flex-1 space-y-6 py-1 w-1/2 mt-6">
      <div class="space-y-3">
        <div class="h-10 bg-slate-200 rounded"></div>
        <div class="grid grid-cols-3 gap-4">
          <div class="h-2 bg-slate-200 rounded col-span-2"></div>
          <div class="h-2 bg-slate-200 rounded col-span-1"></div>
        </div>
        <div class="h-2 bg-slate-200 rounded"></div>
      </div>

      <div class="grid grid-cols-3 gap-4 mt-12">
        <div class="h-32 w-full bg-slate-200 rounded col-span-1"></div>
        <div class="space-y-3 col-span-2">
          <div class="h-2 bg-slate-200 rounded"></div>
          <div class="h-2 bg-slate-200 rounded"></div>
          <div class="h-2 bg-slate-200 rounded"></div>
          <div class="h-2 bg-slate-200 rounded"></div>
        </div>
      </div>
    </div>
  `;
};

export default Skeleton;
